import { Col, Row } from 'antd';
import ForeignAuthorTag from 'components/ForeignAuthorTag';

import ArticleGroup from '../ArticleHeaderGroup/ArticleGroup';

import EditableTitle from './EditableTitle';
import PaymentInfoButton from './PaymentInfoButton';
import TimeLineButton from './TimeLineButton';

/**
 * Madde detay sayfası header'ı. Başlık, grup bilgisi ve timeline butonunu render eder.
 * @param {Object} props
 * @param {string} props.title - Madde başlığı
 * @param {number} props.offerId - Madde teklifi numeric ID'si
 * @param {boolean} props.isView - Timeline görünüm durumu
 * @param {boolean} [props.isShowEditButton=false] - Başlık düzenleme butonu gösterilsin mi
 * @param {boolean} [props.isShowArticleGroup=false] - Grup bilgisi gösterilsin mi
 * @param {boolean} props.isShowTimelineButton - Timeline butonu gösterilsin mi
 * @param {boolean} [props.isForeignAuthorProcess=false] - Madde yabancı yazarlı sipariş ve telif sürecinde mi; true ise başlığın yanına süreç rozeti basılır
 * @param {{ offerId: string, offerTitle: string, offerNumericId: number, offerStatus: number, offerStep: number }} [props.autoAddArticle] - Grup modalına geçilecek otomatik ekleme bilgisi
 * @param [props.isShowPaymentInfoButton=false] - "Ödeme Bilgileri" butonu gösterilsin mi
 * @param props.offer - Madde teklifi; ödeme bilgileri modalına geçilir
 */
function ArticleHeaderGroup({
  title,
  offerId,
  isView,
  isShowEditButton,
  isShowArticleGroup = false,
  isShowTimelineButton,
  isForeignAuthorProcess = false,
  autoAddArticle,
  isShowPaymentInfoButton = false,
  offer,
}) {
  return (
    <Row
      justify="space-between"
      gutter={3}
    >
      <div className="gx-d-flex gx-align-items-center">
        <Col>
          <EditableTitle
            title={title}
            offerId={offerId}
            isShowEditButton={isShowEditButton}
          />
        </Col>
        {/* Başlık alanı sekmelerin üstünde durduğu için rozet her sekmede görünür kalır. */}
        <ForeignAuthorTag
          isForeign={isForeignAuthorProcess}
          label="Yabancı Yazar Süreci"
          className="gx-ml-2"
        />
        {isShowArticleGroup && <ArticleGroup offerId={offerId} autoAddArticle={autoAddArticle} />}
      </div>
      <div className="gx-d-flex gx-align-items-center">
        {isShowPaymentInfoButton && <PaymentInfoButton offer={offer} />}
        {isShowTimelineButton && <TimeLineButton isView={isView} />}
      </div>
    </Row>
  );
}
export default ArticleHeaderGroup;
